import { CheckIcon, CopyIcon } from 'lucide-react';
import { useEffect, useState } from 'react';

/** UUID 같은 긴 식별자를 클립보드로 복사한다. 복사 직후 잠깐 체크 표시로 바뀐다. */
export function CopyIdButton({ value, label }: { value: string; label: string }) {
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!copied) return;
    const timer = setTimeout(() => {
      setCopied(false);
    }, 1500);
    return () => {
      clearTimeout(timer);
    };
  }, [copied]);
  return (
    <button
      type="button"
      aria-label={copied ? `${label} 복사됨` : `${label} 복사`}
      title={`${label} 복사`}
      className="text-muted-foreground hover:text-foreground focus-visible:ring-ring inline-flex size-6 shrink-0 items-center justify-center rounded-sm outline-none focus-visible:ring-2"
      onClick={(event) => {
        event.stopPropagation();
        navigator.clipboard.writeText(value).then(
          () => {
            setCopied(true);
          },
          () => undefined,
        );
      }}
    >
      {copied ? <CheckIcon className="size-3.5" /> : <CopyIcon className="size-3.5" />}
    </button>
  );
}

/** 지점 셀 — 이름을 아는 경우 이름을 위에, UUID는 보조 텍스트로 아래에 둔다. */
export function PropertyCell({ id, name }: { id: string; name: string | undefined }) {
  return (
    <span className="flex min-w-0 flex-col gap-0.5 whitespace-normal">
      {name && <span className="font-medium">{name}</span>}
      <span className="flex items-start gap-1">
        {/* 36자 UUID를 글자 단위로 꺾으면 좁은 폭에서 열이 한 글자로 눌려 행이 수백 px로 길어진다 — 한 줄로 두고 표를 가로 스크롤한다. */}
        <span
          className={name ? 'caption text-muted-foreground whitespace-nowrap' : 'whitespace-nowrap'}
        >
          {id}
        </span>
        <CopyIdButton value={id} label="지점 ID" />
      </span>
    </span>
  );
}
